import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { supabase } from "@/integrations/supabase/client";
import { initPushListeners, enablePush, getPushPermissionState } from "@/lib/push";

/**
 * Native-only: wires push listeners once and refreshes the device token
 * on launch if the user already granted permission previously.
 * Renders nothing.
 */
export default function PushBootstrapper() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    initPushListeners((path) => navigate(path));

    let cancelled = false;
    (async () => {
      // Wait until we have a session before re-registering, so the token
      // upsert can run against the user's RLS policy.
      const { data } = await supabase.auth.getSession();
      if (cancelled || !data.session) return;
      const state = await getPushPermissionState();
      if (state === "granted") {
        await enablePush();
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return null;
}
